'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptGroup = exports.Option = undefined;

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

var _Option = require('./Option');

var _Option2 = _interopRequireDefault(_Option);

var _OptGroup = require('./OptGroup');

var _OptGroup2 = _interopRequireDefault(_OptGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Select2["default"].Option = _Option2["default"];
_Select2["default"].OptGroup = _OptGroup2["default"];
exports.Option = _Option2["default"];
exports.OptGroup = _OptGroup2["default"];
exports["default"] = _Select2["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/_rc-select@6.8.4@rc-select/lib/index.js
 ** module id = 234
 ** module chunks = 0 1
 **/